<template>
  <div id="sidesun-page">
    <div class="sidesun-nav">
      <TopNav saCity="o2o_xuanguzhang_chengshi_01"
              titleName = '身边苏宁' @listenChild="showCity" :city="cityName"></TopNav>
    </div>

    <div v-show="nearStore.length > 0">
    <!--banner-->
    <div id="home-banner" v-show="banner.length > 0">
      <ul>
        <li v-for="item in banner" name="o2o_shouye_lianban_01">
          <a :href="item.linkAddress">
            <img :src="item.actPic | urlProtocol" alt="">
          </a>
        </li>
      </ul>
      <div class="banner-page">
        <span v-for="item in banner"></span>
      </div>
    </div>
    <!--icon-->
    <div id="home-icons" v-show="iconData.length > 0">
      <ul>
        <li v-for="(item, index) in iconData" :name="'o2o_shouye_icon_' + index">
          <a :href="item.iconUrl">
            <img :src="item.iconImage | urlProtocol" alt="">
            <span>{{item.iconName}}</span>
          </a>
        </li>
      </ul>
    </div>
    <!--头条-->
    <div class="topic-list" v-show="topicList.length > 0">
      <h2></h2>
      <div class="marquee-box">
        <div id="marquee-scroll">
          <div class="marquee-item" v-for="item in topicList" name="o2o_shouye_toutiao_01">
            <span v-if="item.linkAddress" @click="subscribe(item.linkAddress)">{{item.actName}}</span>
            <!--<span v-if="!item.linkAddress" @click="goActivity(item.linkAddress)">{{item.actName}}</span>-->
          </div>
          <template v-if="topicList.length > 1">
            <div class="marquee-item" v-if="topicList[0].linkAddress">
              <span @click="subscribe(topicList[0].linkAddress)">{{topicList[0].actName}}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!--头条end-->

    <!--精选活动-->
    <div id="handpick" :class="'handpick-' + handpick.length" v-if="handpick.length > 1">
      <h2 class="module-header">-精选活动-</h2>
      <div v-for="item in handpick" name="o2o_shouye_jingxuan_01">
        <a :href="item.activityUrl">
          <img :src="item.activePicUrl | urlProtocol" alt="">
        </a>
      </div>
    </div>
    <!--优选生活-->
    <div id="excellent-life" class="excellent-life" v-if="excellentLife.length > 0">
      <h2 class="module-header">-优选生活-</h2>
      <div v-for="item in excellentLife" name="o2o_shouye_youxuan_01">
        <a :href="item.linkAddress">
          <img :src="item.actPic | urlProtocol" alt="">
          <h3>{{item.actName}}</h3>
          <p>{{item.actIntro}}</p>
        </a>
      </div>
    </div>

    <!--AD-->
    <div id="home-ad" v-show="ad.length > 0">
      <ul>
        <li v-for="item in ad" name="o2o_shouye_hengtong_01">
          <a :href="item.linkAddress">
          <img :src="item.actPic | urlProtocol" alt="">
          </a>
        </li>
      </ul>
      <div class="ad-page">
        <span v-for="item in ad"></span>
      </div>
    </div>
    </div>

    <!--附近门店-->
    <div class="near-store-container" v-show="nearStore.length > 0">
      <h2 class="module-header">-附近门店- <span class="mh-more" @click="toNearStoreMore" name="o2o_shouye_gengduo_01">更多</span></h2>
      <div id="near-store">
      <li class="near-store-item" v-for="(item,index) in nearStore" :name="item.sa">
        <span class="ns-kli" v-if="item.dist">{{item.dist}}KM</span>
        <div class="ns-img" :class="[{'default-logo': !item.picUrl}, 'store-type-' + item.storeType]">
          <a :href="item.jumpUrl" @click="prompt(item.storeType)">
            <img v-if="item.picUrl" :src="item.picUrl | urlProtocol" alt="">
          </a>
        </div>
        <div class="ns-detail">
          <a :href="item.jumpUrl" @click="prompt(item.storeType)">
            <h2>{{item.storeName}}</h2>
            <div class="ns-tag">
              <span v-for="tag in item.tags">{{tag}}</span>
            </div>
          </a>
          <a :href="item.jumpUrl">
            <div class="ns-act-container" v-if="item.activity && item.activity.length > 0" :class="{'act-more': item.isActMore}" >
              <div class="ns-act-item" v-for="activity in item.activity">
                <span class="act-tag">促销</span>
                <span>{{activity.title}}</span>
                <span class="act-arrow" v-if="item.activity.length > 1" @click.prevent="moreAct(item.storeCode)"></span>
              </div>
            </div>
          </a>
          <!--导购小于4个时不展示，多余4个时只展示4个-->
          <div class="ns-guide" v-if="item.windowList && item.windowList.length > 0">
            <div v-for="guide in item.windowList" :class="guide.type">
              <div class="ns-guide-pic">
                <a :href="guide.link">
                  <img :src="guide.img | urlProtocol" alt="">
                </a>
              </div>
              <span>{{guide.name}}</span>
            </div>
          </div>
        </div>
      </li>
      </div>
      <div class="sn-loading-type">
        <span class="sn-pull-loading hide">上拉精彩无限</span>
        <div class="sn-end-loading hide"><span>没有更多了</span></div>
      </div>
      <div class="loadmore" data-loaded=""></div>
    </div>
    <City :isActive="isAddressShow" @listenChild="receiveCityData" :initSelect="addressInit" v-if="addressInit.length > 0"></City>
    <div class="noon-info" v-if="base.noStore">
      <h2>当前城市暂无门店</h2>
      <p>换一个城市试试</p>
    </div>

    <div id="cx-act-mask" v-if="cxAct.actShow">
      <div class="cx-act">
        <a :href="cxAct.link">
          <img :src="cxAct.img | urlProtocol" alt="">
        </a>
        <span class="act-close" @click="closeAct"></span>
      </div>
    </div>
    <input type="hidden" id="pagename" value="pgcate=10009;tag=100043;pgtitle=身边苏宁-身边苏宁首页">
  </div>

</template>
<script>
  //导入模块
  import CONF from '@/app.conf.json';
  import Server from '../services/Entrance';
  import {Util} from '../commons/util'

  import TopNav from '@/components/commons/TopNav'
  import City from '@/components/commons/City'

  import _ from 'lodash';

  var bannerSwiper = null,
    adSwiper = null;

  export default {
    name: 'Home',
    data () {
      return {
      	base:{
      		noStore: false
        },
        banner: [], // 顶部banner
        iconData: [],
        topicList: [], // 头条
        handpick: [], //精选活动
        excellentLife: [], // 优选生活
        ad: [],
        nearStore: [], // 附近门店模块
        cityName: '', // 右上角地理定位城市
        isAddressShow: 0, // 是否显示城市筛选组件
        totalPage: 100,
        loadable: false,
        queryCondition: { // 查询条件
          cityId: '',
          districtId: '',
          queryVal: '',
          storeType: '',
          cbdId: '',
          longitude: '',
          latitude: '',
          queryType: 4,
          pageNumber: 1
        },
        // 大促活动
        cxAct: {
          img: '',
          link: '',
          actShow: false
        },
        locationData: [],
        addressInit: []
      }
    },
    // 生命周期钩子
    beforeRouteEnter(to, from, next) {

      Wap.Geo(meta => {
        let latitude = meta.location.lat || meta.location.lati;
        let longitude = meta.location.lng || meta.location.longi;

        if ($.isApp) {
          latitude = meta.location.lng || meta.location.longi;
          longitude = meta.location.lat || meta.location.lati;
        }

        let locationData = [
            {mdmId: meta.provinceCode, name: meta.provinceName},
            {cityCode: meta.cityCode, cityNo: meta.cityNo, cityName: meta.cityName}
          ];

        locationData[1].cityName = locationData[1].cityName.replace('市','') + '市';

        next(vm => {
          vm.locationData = locationData;
          vm.queryCondition.cityId = meta.cityCode;
          vm.queryCondition.latitude = latitude;
          vm.queryCondition.longitude = longitude;
        });
      });
    },
    mounted () {
      document.title="身边苏宁";
      let _this = this;

      //_this.geoFn().then(data => {



        // banner
        setTimeout(() => {
          // 大促弹窗
          if (!$.cookie('act')) {

            let today = new Date(),
              tomorry = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

            let expires = (tomorry - today) / 1000;
            // 获取大促活动
            Server.home.queryAdvertInfo(_this.queryCondition.cityId).then(data => {

              if (data.actPic) {
                _this.cxAct.img = data.actPic;
                _this.cxAct.link = data.linkAddress;
                _this.cxAct.actShow = true;

                setTimeout(() => {
                  _this.cxAct.actShow = false;
                }, 5000);

                $.cookie("act", "1", {expires: expires});
              }
            });
          }

          // lazyload
          let $loadMore = $(".loadmore"),
              $pullLoading = $(".sn-pull-loading"),
              $snEndLoading = $(".sn-end-loading");

          $loadMore.lazyload(function (el) {


            if (!_this.loadable) {

              return;
            }

            _this.loadable = false;

            if (_this.queryCondition.pageNumber >= _this.totalPage) {

              $pullLoading.hide();
              $snEndLoading.show();
              el.attr("data-loaded", "done");
              return;
            }

            _this.queryCondition.pageNumber++;

            Server.home.queryHomeNearStore(_this.queryCondition).then(data => {

              _this.nearStore = _this.nearStore.concat(_this.dealNearStoreData(data.datas));
              _this.loadable = true;
            });
            $pullLoading.show();
          });
        }, 200);
      //});
    },
    components: {
      TopNav,
      City
    },
    watch: {
      // 选择城市完成，整个页面的数据都要刷新
      'locationData': {
        handler: function (newVal, oldVal) {

          window.scrollTo(0,0);

          let _this = this;
          _this.cityName = newVal[1].cityName;
          _this.queryCondition.cityId = newVal[1].cityCode;
          _this.queryCondition.pageNumber = 1;
          _this.getNearStore();

          _this.addressInit = [
            {
              mdmId: newVal[0].mdmId,
              name: newVal[0].name
            },{
              lesId: newVal[1].cityCode,
              name: newVal[1].cityName
            }
          ];


          let activityChooseNewReqPromise = Server.home.queryActivityChooseNew(_this.queryCondition.cityId),
            homeIconReqPromise = Server.home.queryHomeIcon(_this.queryCondition.cityId),
            homeADReqPromise = Server.home.queryHomeAD(_this.queryCondition.cityId);

          Promise.all([activityChooseNewReqPromise, homeIconReqPromise, homeADReqPromise])
            .then(([chooseNewData, iconData, AdData]) => {

            // 顶部banner
            _this.banner = chooseNewData.data.lifeChooseConfirm.RollList;
            // 头条
            _this.topicList = chooseNewData.data.lifeChooseConfirm.topicList;
            // 精选活动
            _this.handpick = chooseNewData.data.storeActivityList ? chooseNewData.data.storeActivityList.slice(0, 2) : [];
            // 优选生活
            let lifechooseList = chooseNewData.data.lifeChooseConfirm.lifechooseList;
            if (lifechooseList.length >=6) {
              _this.excellentLife = lifechooseList.slice(0, 6);
            } else if (lifechooseList.length >= 3) {
              _this.excellentLife = lifechooseList.slice(0, 3);
            } else {
              _this.excellentLife = [];
            }
            // AD
            _this.ad = AdData.data;

            // icon 区域
            let icon = iconData.data;

            if(icon.length < 5) {
              _this.iconData = [];
            } else if (icon.length < 10) {
              _this.iconData = icon.slice(0, 5);
            } else if (icon.length >= 10) {
              _this.iconData = icon.slice(0, 10);
            }

            bannerSwiper = adSwiper = null;
            setTimeout(() => {
              if ($('#home-banner').length) {
                let $page = $('.banner-page span');
                $page.eq(0).addClass('cur');
                bannerSwiper = Swipe(document.getElementById("home-banner"), {
                  startSlide: 0,
                  auto: 3000,
                  continuous: true,
                  disableScroll: false,
                  stopPropagation: true,
                  callback: function (index, elem) {
                    $page.eq(index).addClass("cur").siblings().removeClass("cur");
                  }
                });
              }

              if ($('#home-ad').length) {
                let $page = $('.ad-page span');
                $page.eq(0).addClass('cur')
                adSwiper = Swipe(document.getElementById("home-ad"), {
                  startSlide: 0,
                  auto: 3000,
                  continuous: true,
                  disableScroll: false,
                  stopPropagation: true,
                  callback: function (index, elem) {
                    $page.eq(index).addClass("cur").siblings().removeClass("cur");
                  }
                });
              }

              // 头条滚动
              let idx = 0,
                scrollH = $('.marquee-box').height(),
                scrollLen = $('#marquee-scroll .marquee-item').length,
                $scroll = $('#marquee-scroll');

              $scroll.css({top: 0});

              if (scrollLen > 1) {
                setInterval(() => {
                  idx++;
                  if  (idx >= scrollLen) {
                    idx = 1;
                    $scroll.css({
                      top: 0
                    });
                  }

                  $scroll.animate({
                    top: -idx * scrollH
                  }, 500);
                }, 3000)
              }
            }, 200)
          });
        },
        deep: true
      }
    },
    methods: {
      toNearStoreMore() {
        let _this = this;
        window.location.href = `${CONF.otherPage.SearchStore}${_this.queryCondition.cityId}`;
      },
      closeAct() {
        this.cxAct.actShow = false;
      },
      getNearStore() {
        let _this = this;
        Server.home.queryHomeNearStore(_this.queryCondition).then(data => {

          _this.nearStore = _this.dealNearStoreData(data.datas);
          _this.base.noStore = !_this.nearStore.length;
          _this.totalPage = data.pageCount;
          if(data.isLastPage){
            console.log(data)
            // lazyload
            $(".loadmore").attr('load-more','done')
            $(".sn-pull-loading").hide();
            $(".sn-end-loading").show();

          }else {
            _this.loadable = true;
          }
        });
      },
      dealNearStoreData(data) {

        let _this = this;
        _.forEach(data, item => {

          // 处理页面跳转的url
          let storeType = item.storeType * 1,
            linkUrl = '';

          let saArr = {
            type1: 'o2o_shouye_dianqi_01',
            type2: 'o2o_shouye_zhiyingdian_01',
            type3: 'o2o_shouye_xiaodian_01',
            type4: 'o2o_shouye_chaoshi_01',
            type5: 'o2o_shouye_honghaizi_01',
            type6: 'o2o_shouye_suningguanchang_01',
            type7: 'o2o_shouye_shenghuoguangchang_01',
            type8: 'o2o_shouye_weixiu_01',
            type9: 'o2o_shouye_dianqijingxuan_01',
            type10: 'o2o_shouye_caifu_01',
            type11: '',
            type12: 'o2o_shouye_youle_01',
            type13: 'o2o_shouye_youqu_01',
            type14: 'o2o_shouye_tiyu_01',
            type15: 'o2o_shouye_jiwu_01'
          };

          if (storeType >= 1 && storeType <= 15) {
            item.sa = saArr['type' + storeType];
          } else {
            item.sa = '';
          }

          if (storeType === 1 || storeType === 5 || storeType === 8 || storeType === 9 || storeType === 13 || storeType === 14) {
            linkUrl = `${CONF.otherPage.electricShop}${storeType}/${item.storeCode}/${_this.queryCondition.cityId}`;
          } else if (storeType === 2) {
            linkUrl = `${CONF.otherPage.station}${_this.queryCondition.cityId}/${item.storeCode}`;
          } else if (storeType === 3) {
            linkUrl = `${CONF.otherPage.homeNavToType3}?storeCode=${item.storeCode}&lng=${_this.queryCondition.longitude}&lat=${_this.queryCondition.latitude}`;
          } else if (storeType === 4) {
            linkUrl = `${CONF.otherPage.homeNavToType4}?storeCode=${item.storeCode}&lng=${_this.queryCondition.longitude}&lat=${_this.queryCondition.latitude}`;
          } else if(storeType === 10){
            linkUrl = `${CONF.otherPage.homeNavToType10}${item.storeCode}`;
          } else if(storeType === 12 || storeType === 15){
            linkUrl = 'javascript:void(0);'
          } else if(storeType === 6 || storeType === 7){
            if(item.jumpUrl){
              linkUrl = item.jumpUrl;
            }else {
              linkUrl = `${CONF.otherPage.electricShop}0/0/0`;
            }
          } else {
            linkUrl = `${CONF.otherPage.electricShop}0/0/0`;
          }

          item.jumpUrl = linkUrl;

          // 电器店|红孩子母婴，有导购优先展示导购，无导购展示橱窗，无橱窗不展示
          // 1 电器店， 5 红孩子， 11影城
          // if (item.storeType == 1 || item.storeType == 5 || item.storeType == 11) {

            // 导购
            if (item.guider && item.guider.uservantUserInfos && item.guider.uservantUserInfos.length >= 4) {
              let guiders = item.guider.uservantUserInfos,
                guiderList = [];

              for (let i = 0; i < 4; i++) {
                guiderList.push({
                  type: 'guide',
                  img: guiders[i].guidePhoto,
                  id: guiders[i].guideId,
                  link: guiders[i].url,
                  name: guiders[i].guideName
                });
              }
              item.windowList = guiderList;
              delete item.guider;
            } else if (item.window && item.window.length >= 4) {

              let windows = item.window,
                windowList = [];

              for (let i = 0; i < 4; i++) {
                windowList.push({
                  type: item.storeType == 11 ? 'window-movie' : 'window',
                  img: windows[i].newWindowImage,
                  id: windows[i].windowId,
                  link: windows[i].functionAddress,
                  name: windows[i].windowDes
                });
              }
              item.windowList = windowList;
              delete item.window;

            } else {
              // 导购和橱窗都不展示
              item.windowList = [];
            }
          //}

          // 标签
          if (item.storeLabel && item.storeLabel.trim().length > 0) {
            item.tags = item.storeLabel.trim().split(',');
          }

          item.isActMore = false;

        });

        return data;
      },
      receiveCityData(e) {

//        document.removeEventListener('touchmove', eventDefault, false);

        let locationData = [
          {
            mdmId: e[0].mdmId,
            name: e[0].name
          },
          {
            cityCode: e[1].lesId,
            cityNo: e[1].commerceId,
            cityName: e[1].name
          }
        ];

        locationData[1].cityName = locationData[1].cityName.replace('市','') + '市';

        this.locationData = locationData;
      },
      showCity() {
        this.isAddressShow++;
      },
      subscribe(linkUrl) {
        window.location.href = linkUrl;
      },
      moreAct(code) {

        let _this = this;
        _.forEach(_this.nearStore, item => {
          if (item.storeCode === code) {
            item.isActMore = !item.isActMore;
          }
        });
      },
      geoFn() {

        let _this = this;
        return new Promise((reslove, reject) => {

          if (_this.queryCondition.latitude && _this.queryCondition.longitude) {

            reslove({status: true});
          } else {
            Wap.Geo(meta => {

              let _locationData = [
                {mdmId: meta.provinceCode,name: meta.provinceName},
                {cityCode: meta.cityCode,cityNo: meta.cityNo,cityName: meta.cityName}
              ];
              _locationData[1].cityName = _locationData[1].cityName.replace('市','') + '市';
              _this.locationData = _locationData;

              _this.queryCondition.cityId = meta.cityCode;
              _this.queryCondition.latitude = meta.location.lat || meta.location.lati;
              _this.queryCondition.longitude = meta.location.lng || meta.location.longi;
              reslove({status: true});
            });
          }
        });
      },
      prompt(storeType){
        if(storeType === '12' || storeType === '15'){
          AlertBox({
            type:'mini',
            msg:'此业态暂未开放'
          });
          return false
        }
      }
    }
  }
</script>
<style scoped>

  #sidesun-page {
    padding-top: 1.76rem;
    background: #f2f2f2;

    .sidesun-nav {
      display: block;
      height: 1px;
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9;
    }

    .loadmore {
      height: 1px;
    }

    #home-ad{
      margin-bottom: 20px;
    }
    #home-banner, #home-ad {
      width: 100%;
      height: 280px;
      position: relative;
      overflow: hidden;

      ul {
        height: 100%;
        overflow: hidden;
      }

      li {
        position: relative;
        float: left;
      }
      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: block;
      }

      .banner-page ,.ad-page{
        position: absolute;
        bottom: 10px;
        right: 10px;
        height: 5px;

        span {
          display: block;
          float: left;
          width: 15px;
          height: 5px;
          background: #fff;
          opacity: 0.4;

          &.cur {
             opacity: 1;
          }
        }
      }
    }
    #home-ad {
      height: 200px !important;
    }

    /*banner end*/
    #home-icons {
      background: #fff;
      width: 100%;
      padding: 20px 0 0 0;
      box-sizing: border-box;

      ul {
        height: auto;
        overflow: hidden;
      }

      li {
        width: 150px;
        text-align: center;
        margin: 0 0 20px 0;
        float: left;
        font-family: "PingFangSC-Regular";
        font-size: 24px;
        color: #222222;
        letter-spacing: 0;

        &:nth-of-type(5n + 5) {
          margin-right: 0;
        }

        img {
          margin: 0 auto;
          margin-bottom: 15px;
          border-radius: 50%;
          width: 82px;
          height: 82px;
          overflow: hidden;
          display: block;
        }
      }
    }

    .topic-list {
      background: #fff;
      padding: 0 20px;
      height: 70px;
      line-height: 70px;
      margin-bottom: 20px;
      border-top: 1px solid #f8f8f8;
      border-bottom: 1px solid #f8f8f8;

      h2 {
        float: left;
        font-family: "PingFangSC-Medium";
        font-size: 34px;
        color: #222222;
        background: url("../assets/tt.png") 0 50% no-repeat;
        background-size: 154px 36px;
        padding-right: 20px;
        width: 154px;
        height: 70px;
        position: relative;

        &:after {
           position: absolute;
           top: 50%;
           margin-top: -15px;
           right: 0;
           content: '';
           display: block;
           width: 2px;
           height: 30px;
           background: #D9D9D9;
        }
      }

      .marquee-box {
        top: 10px;
        overflow: hidden;
        height: 50px;
        position: relative;
        display: block;
        text-indent: 15px;
        font-family: "PingFangSC-Regular";
        font-size: 24px;
        color: #444444;

        #marquee-scroll {
          height: auto;
          position: absolute;
          left: 0;
          top: 0;
          margin-left: 20px;
        }

        span {
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          &:before{
            content: '';
            position: absolute;
            top: 21px;
            display: block;
            width: 8px;
            height: 8px;
            border-radius: 8px;
            background: #cccccc;
           }
        }
      }
    }

    .module-header {
      font-size: 34px;
      color: #333333;
      text-align: center;
      font-weight: bold;
      height: 91px;
      line-height: 91px;
      position: relative;
      background: #ffffff;

      .mh-more {
        display: block;
        width: 100px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 20px;
        text-align: right;
        font-family: "PingFangSC-Regular";
        font-weight: normal;
        font-size: 24px !important;
        color: #999999;
      }
    }
  }

  #handpick {
    margin-top: 20px;
    background: #ffffff;
    overflow: hidden;
    padding: 0 20px 20px 20px;
    height: auto;

    img {
      width: 100%;
      height: 100%;
      display: block;
      overflow: hidden;
      border-radius: 5px;
    }


    &.handpick-2 {

      > div {
        overflow: hidden;

        &:nth-of-type(1) {
          width: 350px;
          height: 212px;
          float: left;
        }

        &:nth-of-type(2) {
          width: 350px;
          height: 212px;
          float: right;
        }
      }
    }

  }

  #excellent-life {
    margin-top: 20px;
    margin-bottom: 20px;
    background: #ffffff;
    overflow: hidden;
    padding: 0 20px 23px 20px;
    height: auto;

    > div {

      h3 {
        font-size: 30px;
        color: #444444;
        margin-top: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 24px;
        color: #999999;
        margin-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    img {
      width: 100%;
      height: 100%;
      display: block;
      overflow: hidden;
      border-radius: 5px;
    }
    &.excellent-life {


      > div {
        width: 230px;
        margin-right: 10px;
        margin-bottom: 15px;
        display: inline-block;

        img {
          width: 230px;
          height: 137px;
        }

        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }
    }
  }
  /*优选生活 end*/

  /* near store*/
  #near-store {
    background: #fff;
    padding: 0 20px;

    .near-store-item {
      height: auto;
      overflow: hidden;
      border-bottom: 1px solid #f7f7f7;
      padding: 20px 0;
      position: relative;

      .ns-kli {
        position: absolute;
        top: 20px;
        right: 0;
        background: #EEEEEE;
        font-size: 22px;
        color: #999999;
        padding: 0 10px;
        border-radius: 5px;
      }
    }

    .ns-img {
      display: block;
      width: 120px;
      height: 120px;
      float: left;

      a {
        display: block;
        width: 100%;
        height: 100%;
      }

      &.default-logo {

        @for $i from 1 to 15 {
          &.store-type-$i {
            background: url("../assets/store-type-$(i).jpg") 0 0 no-repeat;
            background-size: 100%;
          }
        }

        &.store-type-undefined {
           background: url("../assets/store-type-8.jpg") 0 0 no-repeat;
           background-size: 100%;
        }
      }
      img {
        display: block;
        overflow: hidden;
        width: 100%;
        height: 100%;
      }
    }
    .ns-detail {
      overflow: hidden;
      padding-left: 20px;

      h2 {
        font-family: "PingFangSC-Medium";
        font-size: 32px;
        color: #333333;
        line-height: 36px;
        /*font-weight: bold;*/
        width: 80%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .ns-tag {
        margin-top: 14px;

        span {
          font-family: PingFangSC-Regular;
          font-weight: normal;
          border: 1px solid #cccccc;
          border-radius: 2px;
          margin-right: 10px;
          padding: 2px 12px;
          color: #333333;
          font-size: 24px;
          display: inline-block;
        }
      }

      .ns-act-container {
        margin-top: 25px;
        font-family: "PingFangSC-Regular";
        font-size: 22px;
        color: #FF9900;
        letter-spacing: 0;
        line-height: 30px;

        &.act-more {
           .ns-act-item {
             display: block;
           }
           .act-arrow{
             transform: rotate(-180deg);
           }
        }

        .ns-act-item {
          /*height: 50px;*/
          position: relative;
          padding-bottom: 15px;
          display: none;

          .act-arrow {
            display: none;
          }

          &:nth-of-type(1) {
            display: block;

            .act-arrow {
              display: block;
            }
          }
        }
        .act-arrow {
          transform: rotate(0);
          position: absolute;
          top: 2px;
          right: 0;
          background: url("../assets/arrow-icon.png") center no-repeat;
          display: block;
          width: 28px;
          height: 28px;
          background-size: 20px 20px;
          transform-origin: center;
        }

        .act-tag {
          background: #FF9900;
          padding: 2px 7px;
          font-size: 20px;
          color: #ffffff;
          margin-right: 10px;
          border-radius: 2px;
        }
      }
      .ns-guide {
        margin-top: 15px;
        height: auto;
        overflow: hidden;

        > div {
          float: left;
          width: 128px;
          margin-right: 19px;
          overflow: hidden;
          height: auto;
          font-family: "PingFangSC-Regular";
          text-align: center;
          font-size: 24px;
          color: #222222;
          letter-spacing: 0.52px;
          line-height: 30px;

          &:nth-last-of-type(1) {
            margin-right: 0 !important;
          }

          &.guide {
            width: 80px;
            margin-right: 82px;
            .ns-guide-pic {
              width: 80px;
              height:  80px;
              img {
                display: block;
                overflow: hidden;
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          &.window {
            width: 128px;
            margin-right: 19px;
            color: #FF6600;
            .ns-guide-pic {
              width: 128px;
              height: 128px;

              img {
                display: block;
                width: 128px;
                height: 128px;
              }
            }
          }
          &.window-movie {
            width: 128px;
            margin-right: 19px;

            .ns-guide-pic {
              width: 128px;
              height:  176px;

              img {
                display: block;
                width: 128px;
                height: 128px;
              }
            }
          }
        }

        span {
          display: block;
          padding-top: 20px;
        }
      }
    }
  }

  #cx-act-mask {
    z-index: 1500;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: hsla(0, 0%, 0%, .8);

    .cx-act {
      position: absolute;
      width: 611px;
      height: 711px;
      left: 50%;
      top: 50%;
      margin-left: -305px;
      margin-top: -355px;
      overflow: hidden;
      border-radius: 30px;

      img {
        width: 100%;
        display: block;
        overflow: hidden;
      }
    }

    .act-close {
      display: block;
      width: 70px;
      height: 70px;
      z-index: 1000;
      background: url("../assets/sno2o_MPF_CloseBtn@2x.png") 0 0 no-repeat;
      background-size: 70px 70px;
      position: absolute;
      top: 20px;
      right: 20px;
    }

  }
  .noon-info {
    padding-bottom: 150px;

    &:before {
       margin: 50px auto 41px auto;
       display: block;
       content: '';
       width: 256px;
       height: 297px;
       background: url("../assets/no-city.png") 50% 50% no-repeat;
       background-size: 256px 297px;
     }

    h2 {
      font-family:"PingFangSC-Medium";
      font-size:34px;
      font-weight: 800;
      text-align: center;
      color:#323232;
      width: 100%;
    }

    p {
      font-family:"PingFangSC-Regular";
      font-size:26px;
      color:rgba(3,3,3,0.50);
      text-align:center;
      display: block;
      width: 100%;
      margin-top: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Home.vue